import { makeStyles } from '@material-ui/core/styles';

export const useFormOptionStyles = makeStyles(theme => ({
  formOption: {
    flexGrow: 1
  }
}));
